import { createContext, useCallback, useState } from "react";

export const ChatAssistantAttachmentContext = createContext();

export function ChatAssistantAttachmentContextProvider({ children, attachments = [] }) {
  const [attachmentsList, setAttachmentsList] = useState(attachments);
  const [promptNameOverride, setPromptNameOverride] = useState(null);
  const [changeRecordsCallback, setChangeRecordsCallback] = useState(null);

  const addAttachments = useCallback((newAttachments) => {
    setAttachmentsList(newAttachments);
  }, []);

  const clearAttachmentsExceptUserProfile = useCallback(() => {
    setAttachmentsList((prevAttachments) => prevAttachments.filter((attachment) => attachment.name === "User Profile"));
  }, []);

  const setPromptName = useCallback((promptName) => {
    setPromptNameOverride(promptName);
  }, []);

  const clearPromptName = useCallback(() => {
    setPromptNameOverride(null);
  }, []);

  const setOnChangeRecords = useCallback((callback) => {
    setChangeRecordsCallback(() => callback);
  }, []);

  const clearOnChangeRecords = useCallback(() => {
    setChangeRecordsCallback(null);
  }, []);

  return (
    <ChatAssistantAttachmentContext.Provider
      value={{
        attachments: attachmentsList,
        addAttachments,
        clearAttachmentsExceptUserProfile,
        promptName: promptNameOverride,
        setPromptName,
        clearPromptName,
        onChangeRecords: changeRecordsCallback,
        setOnChangeRecords,
        clearOnChangeRecords,
      }}
    >
      {children}
    </ChatAssistantAttachmentContext.Provider>
  );
}
